import { PaypalPaymentPayerModal } from "./PaypalPaymentPayer.model";
import { PaypalPaymentTransactionModal } from "./PaypalPaymentTransaction.model";

export class PaypalPaymentDoneModal {
    intent: string="sale";
    payer: PaypalPaymentPayerModal;
    transactions:PaypalPaymentTransactionModal[];
}
